import { DeterministicWrapperView } from '@bingads-webui/deterministic-wrapper-view';

export class SingleViewWrapper extends DeterministicWrapperView {
  initialize(options) {
    this.view = options.view;
    this.listenTo(this.view, 'all', this.trigger);
    this.rendered = options.rendered;
  }
}
